import { applyWorkFormDates } from './workFormUtils';

/** row_ids در quick-action باید رشتهٔ جدا شده با کاما باشد: "2,3" */
export const formatWorkQuickActionRowIds = (rowIds) => {
  if (rowIds == null || rowIds === '') return '';
  if (typeof rowIds === 'string') return rowIds;
  if (Array.isArray(rowIds)) return rowIds.filter((id) => id != null && id !== '').join(',');
  return String(rowIds);
};

export const buildWorkQuickActionPayload = (action_type, row_ids, extra = {}) => ({
  action_type,
  row_ids: formatWorkQuickActionRowIds(row_ids),
  ...extra,
});

export const buildContractPayload = (values) =>
  applyWorkFormDates({
    contract_number: values.contract_number,
    subject: values.subject,
    client_id: values.client_id,
    project_id: values.project_id,
    contract_type: values.contract_type,
    currency_id: values.currency_id,
    amount: values.amount,
    start_date: values.start_date,
    end_date: values.without_end ? null : values.end_date,
    description: values.description,
    cell: values.cell,
    office: values.office,
    city: values.city,
    state: values.state,
    postal_code: values.postal_code,
    alternate_address: values.alternate_address,
    note: values.note,
  });

export const buildContractTemplatePayload = (values) => ({
  subject: values.subject,
  description: values.description,
  contract_type: values.contract_type,
  amount: values.amount,
  currency_id: values.currency_id,
});

export const buildContractDiscussionCreatePayload = (comment, contractId) => ({
  comment,
  contract_id: Number(contractId),
});

export const buildContractDiscussionUpdatePayload = (comment) => ({
  comment,
});

export const buildContractRenewCreatePayload = (values, contractId) =>
  applyWorkFormDates({
    contract_id: Number(contractId),
    amount: values.amount,
    start_date: values.start_date,
    end_date: values.end_date,
  });

export const buildContractRenewUpdatePayload = (values) =>
  applyWorkFormDates({
    amount: values.amount,
    start_date: values.start_date,
    end_date: values.end_date,
  });

export const buildProjectPayload = (values, { projectId, isEdit } = {}) => {
  const body = {
    project_code: values.project_code,
    project_name: values.project_name,
    project_summary: values.project_summary,
    client_id: values.client_id,
    category_id: values.category_id,
    start_date: values.start_date,
    deadline: values.without_deadline ? null : values.deadline,
    notes: values.notes,
    currency_id: values.currency_id,
    project_budget: values.project_budget,
    hours_allocated: values.hours_allocated,
    user_id: values.user_id || [],
    public_gantt_chart: values.public_gantt_chart || 'disable',
    public_taskboard: values.public_taskboard || 'disable',
    need_approval_by_admin: values.need_approval_by_admin ? 1 : 0,
  };
  // در ویرایش اگر تیم از API قابل بازیابی نبود و کاربر دست نزده، team_id را نفرست تا پاک نشود
  if (!isEdit || values.team_id !== undefined) {
    body.team_id = values.team_id || [];
  }
  if (values.sub_category_id != null && values.sub_category_id !== '') {
    body.sub_category_id = values.sub_category_id;
  }
  if (values.public) body.public = 'on';
  if (values.manual_timelog) body.manual_timelog = 'on';
  if (values.client_task_notification) body.client_task_notification = 'on';
  if (!isEdit && values.template_id != null && values.template_id !== '') {
    body.template_id = Number(values.template_id);
  }
  if (isEdit) {
    if (values.status) body.status = values.status;
    if (projectId != null) body.project_id = Number(projectId);
  }
  return applyWorkFormDates(body);
};

export const buildProjectTemplatePayload = (values) => {
  const body = {
    project_name: values.project_name,
    category_id: values.category_id,
    sub_category_id: values.sub_category_id,
    project_summary: values.project_summary,
    notes: values.notes,
  };
  if (values.manual_timelog) body.manual_timelog = 'on';
  return body;
};

export const buildProjectSubcategoryPayload = (values) => ({
  category_id: values.category_id,
  category_name: values.category_name,
});

export const buildDiscussionCategoryPayload = (values) => ({
  category_name: values.category_name,
  color: values.color,
});

export const buildDiscussionPayload = (values, projectId) => ({
  title: values.title,
  discussion_category: values.discussion_category,
  project_id: Number(projectId),
  description: values.description,
});

export const buildDiscussionReplyPayload = (discussionId, description) => ({
  discussion_id: Number(discussionId),
  description,
});

export const buildProjectNotePayload = (values, projectId) => {
  const type = Number(values.type ?? 0);
  const base = {
    title: values.title,
    type,
    details: values.details,
    project_id: Number(projectId),
  };
  if (type === 0) return base;
  const userIds = Array.isArray(values.user_id) ? values.user_id : values.user_id ? [values.user_id] : [];
  return {
    ...base,
    user_id: userIds.map(Number),
    is_client_show: values.is_client_show ? 1 : 0,
    ask_password: values.ask_password ? 1 : 0,
  };
};

export const buildProjectRatingPayload = (values, projectId) => ({
  rating: values.rating,
  comment: values.comment,
  project_id: Number(projectId),
});

export const buildProjectTemplateMemberPayload = (projectTemplateId, userIds) => {
  const tid = Number(projectTemplateId);
  return {
    project_template_id: tid,
    project_id: tid,
    user_id: userIds || [],
  };
};

export const buildProjectTemplateMemberGroupPayload = (projectTemplateId, groupIds) => {
  const tid = Number(projectTemplateId);
  return {
    project_template_id: tid,
    project_id: tid,
    group_id: groupIds || [],
  };
};

export const buildProjectMemberPayload = (projectId, userIds) => {
  const pid = Number(projectId);
  return { project_id: pid, user_id: userIds || [] };
};

export const buildProjectMemberGroupPayload = (projectId, groupIds) => {
  const pid = Number(projectId);
  return { project_id: pid, group_id: groupIds || [] };
};

export const buildProjectMilestonePayload = (values, projectId) =>
  applyWorkFormDates(
    {
      project_id: Number(projectId),
      milestone_title: values.milestone_title,
      summary: values.summary,
      cost: values.cost,
      status: values.status || 'incomplete',
      currency_id: values.currency_id,
      start_date: values.start_date,
      end_date: values.end_date,
    },
    ['start_date', 'end_date'],
  );

export const buildProjectTemplateTaskPayload = (values, templateId) => ({
  heading: values.heading,
  category_id: values.category_id,
  user_id: values.user_id || [],
  priority: values.priority || 'medium',
  description: values.description,
  task_labels: values.task_labels || [],
  milestone_id: values.milestone_id,
  template_id: Number(templateId),
});

export const buildProjectTemplateMilestonePayload = (values, templateId) =>
  applyWorkFormDates(
    {
      project_id: Number(templateId),
      milestone_title: values.milestone_title,
      summary: values.summary,
      cost: values.cost,
      status: values.status || 'incomplete',
      currency_id: values.currency_id,
      start_date: values.start_date,
      end_date: values.end_date,
    },
    ['start_date', 'end_date'],
  );

export const buildTaskPayload = (values) => {
  const body = {
    heading: values.heading,
    description: values.description,
    category_id: values.category_id,
    project_id: values.project_id,
    board_column_id: values.board_column_id,
    user_id: values.user_id || [],
    task_labels: values.task_labels || [],
    milestone_id: values.milestone_id,
    priority: values.priority || 'medium',
    start_date: values.start_date,
  };
  if (!values.without_duedate) body.due_date = values.due_date;
  if (values.is_private) body.is_private = 1;
  if (values.billable) body.billable = 1;
  if (values.set_time_estimate) {
    body.set_time_estimate = 1;
    body.estimate_hours = values.estimate_hours;
    body.estimate_minutes = values.estimate_minutes;
  }
  if (values.repeat) {
    body.repeat = 1;
    body.repeat_count = values.repeat_count;
    body.repeat_type = values.repeat_type;
    body.repeat_cycles = values.repeat_cycles;
  }
  return applyWorkFormDates(body);
};

export const buildTaskLabelPayload = (values) => {
  const body = {
    label_name: values.label_name,
    color: values.color,
    description: values.description,
  };
  if (values.project_id != null && values.project_id !== '') {
    body.project_id = values.project_id;
  }
  return body;
};

export const buildTaskboardColumnPayload = (values) => ({
  column_name: values.column_name,
  priority: values.priority,
  label_color: values.label_color,
});

export const buildTaskCommentPayload = (taskId, comment) => ({
  task_id: Number(taskId),
  comment,
});

export const buildTaskNotePayload = (taskId, note) => ({
  task_id: Number(taskId),
  note,
});

export const buildSubTaskPayload = (values, taskId) => {
  const rawUser = values.user_id;
  const userId = Array.isArray(rawUser)
    ? rawUser[0]
    : rawUser != null && rawUser !== ''
      ? rawUser
      : undefined;

  return applyWorkFormDates({
    task_id: Number(taskId),
    title: values.title,
    description: values.description,
    start_date: values.start_date,
    due_date: values.due_date,
    ...(userId != null ? { user_id: Number(userId) } : {}),
  });
};
